import { render, staticRenderFns } from "./PackageCategoryView.vue?vue&type=template&id=785524fe&scoped=true"
import script from "./PackageCategoryView.vue?vue&type=script&lang=js"
export * from "./PackageCategoryView.vue?vue&type=script&lang=js"
import style0 from "./PackageCategoryView.vue?vue&type=style&index=0&id=785524fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785524fe",
  null
  
)

export default component.exports